import { useEffect, useState } from 'react';
import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { formatNumbers, getContentKeyAccToLang } from '../../utils/utils';
import {
  createSubscription,
  generateFundSuitability,
  getFundDetail,
  signDocument,
} from '../../store/actions/fund-action';
import { setFundDetail } from '../../store/slices/fund-slice';
import { useLocation, useNavigate } from 'react-router';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { fundsContent } = useSelector((state) => state.content);
  const { fund_loading, fund_detail, fund_document_loading, suitability_data } = useSelector(
    (state) => state.fund,
  );

  const [reviewModal, setReviewModal] = useState(false);
  const [documentUrls, setDocumentUrls] = useState([]);
  const [isTermsModal, setIsTermModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [subscribeData, setSubscribeData] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [successModal, setSuccessModal] = useState(false);
  const [isSuitabilityModal, setIsSuitabilityModal] = useState(false);

  const toogleReviewModal = () => setReviewModal(!reviewModal);

  const item = location?.state?.item;

  useEffect(() => {
    if (item) {
      dispatch(setFundDetail(null));
      dispatch(getFundDetail(`${item?.fundId}&myFund=${false}`));
    } else {
      navigate('/funds/available-funds');
    }
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_subscribe?.data?.attributes,
      key,
      isArabic,
    );
  };

  const handleReviewSubscribe = (values, functions) => {
    if (values?.read_suitability_report) {
      setSubscribeData({ ...values, resetForm: functions?.resetForm });
      toogleReviewModal();
    } else {
      handleGenerateSuitability();
    }
  };

  const handleGenerateSuitability = () => {
    dispatch(
      generateFundSuitability(fund_detail?.subRequestId, () => {
        setIsSuitabilityModal(true);
      }),
    );
  };

  const onVerify = () => {
    const total_amount = Number(subscribeData?.unit || 0) * (fund_detail?.lastPrice || 0)
    const apiData = {
      RequestId: fund_detail?.subRequestId,
      NoOfUnits: Number(subscribeData?.unit || 0),
      TotalAmount: Number(total_amount || 0),
    };

    dispatch(
      createSubscription(apiData, (val) => {
        setSuccessMessage(val?.message);
        subscribeData?.resetForm && subscribeData?.resetForm();
        toogleReviewModal();
        setDocumentUrls([]);
        setSuccessModal(true);
      }),
    );
  };

  const onPressAgree = (id, typeId) => {
    const apiData = {
      SubReqId: fund_detail?.subRequestId,
      FundId: fund_detail?.fundId,
      DocumentId: id,
    };

    dispatch(
      signDocument(apiData, (result) => {
        setDocumentUrls([
          ...documentUrls,
          { documentId: id, typeId, ...result },
        ]);
      }),
    );
  };

  const handleDownloadFile = async (fileUrl) => {
    if (!fileUrl) return;

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileUrl.split('/').pop() || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  const amount = Number(subscribeData?.unit || 0) * (fund_detail?.lastPrice || 0)
  const subscription = fund_detail?.feeApplicable ? (amount * fund_detail?.feeValueInPer) / 100 : 0;
  const vat = fund_detail?.vatApplicable ? (Number(subscription) * fund_detail?.vatValueInPer) / 100 : 0;
  const units = subscribeData?.unit
  const total_amount = Number(amount) + vat + subscription

  return {
    item,
    isArabic,
    fund_detail,
    TextWeight,
    fund_loading,
    subscribeData,
    getContentKey,
    handleReviewSubscribe,
    onVerify,
    isTermsModal,
    setIsTermModal,
    reviewModal,
    toogleReviewModal,
    documentUrls,
    onPressAgree,
    successMessage,
    successModal,
    setSuccessModal,
    navigate,
    fund_document_loading,
    vat,
    subscription,
    total_amount,
    amount,
    setSelectedDocument,
    selectedDocument,
    isSuitabilityModal,
    setIsSuitabilityModal,
    handleGenerateSuitability,
    direction,
    units,
    handleDownloadFile,
  };
};
